// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () =>
    import("apps/traffic-live-map/TrafficLiveMapEntry"),
  orderPrio: 90,
  iconType: "dot-chart",
  name: "traffic"
}: AppType)
